export const BASE_URL = process.env.REACT_APP_API_URL; //'https://localhost:7240/api/' // 'https://webapp-accelerator-webapi-int.azurewebsites.net/api/' // 